import { useTranslation } from 'react-i18next';

type AppTFunction = (key: string, options?: Record<string, unknown>) => string;

export const useAppTranslation = () => {
  const { t, ...rest } = useTranslation();
  return { t: t as AppTFunction, ...rest };
};
